// src/components/Adviser/Pages/EditLicenseCertificatesPage.jsx

import React, { useEffect, useMemo, useState } from "react";
import { Helmet } from "react-helmet-async";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import Sidebar from "../../../../DesignSystem/Sidebar";
import EditLicenseCertificates from "./EditLicenseCertificates";
import {
  subscribeAdviserFullDetailsByEmailOrId,
  subscribeAdviserLicenseCertificateDetailsById,
} from "../../../../../context/Adviser/Utils/AdviserLiveDetails";
import { useAdviserList } from "../../../../../context/Adviser/Utils/AdviserEmailList";

export default function EditLicenseCertificatesPage() {
  const navigate = useNavigate();
  const { state } = useLocation();
  const params = useParams();

  const rawKey =
    params.adviserKey ||
    params.id ||
    params.email ||
    params.adviserId ||
    state?.adviserKey ||
    state?.adviserEmail ||
    "";

  const adviserKey = rawKey ? decodeURIComponent(rawKey) : "";

  const [details, setDetails] = useState(state?.details || null);
  const { advisers } = useAdviserList();
  const directAdviserId =
    state?.adviserId || state?.details?.adviserId || "";

  useEffect(() => {
    if (!adviserKey) return undefined;

    if (directAdviserId) {
      return subscribeAdviserLicenseCertificateDetailsById(
        directAdviserId,
        setDetails,
      );
    }

    return subscribeAdviserFullDetailsByEmailOrId(adviserKey, setDetails);
  }, [adviserKey, directAdviserId]);

  const loading = !details || details.loading;

  const adviserEmail = useMemo(() => {
    return (
      details?.adviserDoc?.email ||
      details?.email ||
      state?.adviserEmail ||
      adviserKey ||
      ""
    );
  }, [details, state, adviserKey]);

  const adviserName = useMemo(() => {
    const personal = details?.personalDetails || {};
    const fullName = [personal?.forename, personal?.surname]
      .filter(Boolean)
      .join(" ")
      .trim();

    return fullName || state?.adviserName || adviserEmail || "Adviser";
  }, [details, state, adviserEmail]);

  return (
    <div className="main-content">
      <Helmet>
        <title>Edit Licence Certificates • {adviserName}</title>
      </Helmet>

      <Sidebar />

      <div className="Main-Container" >
        <EditLicenseCertificates
          adviserName={adviserName}
          adviserId={details?.adviserId || adviserKey}
          adviserEmail={adviserEmail}
          details={details}
          advisers={advisers}
          loading={loading}
          scrollToSection={state?.scrollToSection || ""}
          onSaved={() =>
            navigate(
              state?.returnTo ||
                `/advisers/${encodeURIComponent(adviserKey || adviserEmail)}?tab=licenceCertificates`,
            )
          }
        />

      </div>
    </div>
  );
}
